import { render, staticRenderFns } from "./service2.vue?vue&type=template&id=68f88b43&scoped=true&"
import script from "./service2.vue?vue&type=script&lang=js&"
export * from "./service2.vue?vue&type=script&lang=js&"
import style0 from "./service2.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./service2.vue?vue&type=style&index=1&id=68f88b43&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f88b43",
  null
  
)

export default component.exports